<template>
    <div class="answer-points">
        <span
            v-if="asCheckbox && points > 0"
            class="icon is-small is-right has-text-success"
        >
            <i class="fas fa-check"></i>
        </span>
        <span v-if="!asCheckbox">
            {{ points }}
        </span>
    </div>
</template>

<script>
export default {
    name: "StatisticsAnswerPoints",
    props: {
        points: 0,
        asCheckbox: {
            type: Boolean,
            default: false,
        },
    },
}
</script>